// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  root: {
    marginTop: theme.spacing(1.5),
  },
  rateLine: {
    fontWeight: 500,
  },
  sourceText: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  buttonRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  button: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  form: {
    marginTop: theme.spacing(1),
  },
  rateField: {
    width: '160px',
    marginTop: theme.spacing(0.5),
  },
  notesField: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  historyRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'baseline',
    paddingBottom: theme.spacing(0.5),
  },
  historyChange: {
    minWidth: '140px',
  },
  historyNotes: {
    color: theme.palette.text.secondary,
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
  },
});

export default styles;
